<label
  class="border-custom-primary shadow-md xs:p-3"
  [@zoomIn]
  [class.selected]="selected"
  *ngIf="!hideNullBalance || item.balance > 0">
  <div class="flex w-full justify-start items-center gap-4 xs:gap-2">
    <mat-radio-button
      [checked]="selected"
      [value]="item.currencyIso"
      color="primary"
      (change)="valueSelected.next($event.value)"
      *ngIf="showRadioButton"></mat-radio-button>
    <div class="flex items-center gap-4 xs:gap-2">
      <div class="flex flex-col w-8 h-8 relative">
        <img
          class="flex flex-col object-cover rounded-full h-full object-cover"
          ngSrc="https://flagcdn.com/{{
            item.currencyIso | currencyCountry
          }}.svg"
          [alt]="item.currencyIso"
          fill />
      </div>
      <div>
        <div class="text-xs whitespace-nowrap" *ngIf="!dollarConversion">
          {{ 'currencyCard:currentBalance' | translate }}
        </div>
        <div class="text-xs whitespace-nowrap" *ngIf="dollarConversion">
          {{ 'currencyName:' + item.currencyIso | translate }} ({{
            item.currencyIso
          }})
        </div>
        <div
          class="text-md gt-xs:text-xl whitespace-nowrap"
          *ngIf="!dollarConversion">
          {{
            getParsedBalance(item.balance)
              | currency : item.currencyIso : 'symbol'
          }}
        </div>
        <div
          class="text-xs whitespace-nowrap flex items-center"
          *ngIf="showIncomeBalance && !dollarConversion">
          <i
            class="fa-solid"
            [ngClass]="{
              'fa-arrow-down-left': (lastTransactionValue ?? 0) < 0,
              'fa-arrow-up-left': (lastTransactionValue ?? 0) >= 0
            }"
            [style.color]="
              (lastTransactionValue ?? 0) < 0 ? '#FF0000' : '#059669'
            "></i>
          {{
            (item.lastTransaction
              ? 'currencyCard:lastTransaction'
              : 'currencyCard:noTransactions'
            ) | translate
          }}
          {{ getParsedLastTransaction(item.lastTransaction) | currency }}
        </div>
      </div>
    </div>
  </div>
</label>
